import { graphql } from "relay-runtime";

export const homeAutomatedOpportunityQuery = graphql`
  query HomeAutomatedOpportunityQuery(
    $minInvestmentAgeDays: Int!
    $minValueUsd: Bigint!
  ) {
    finV3 {
      ranges(
        first: 25
        status: OPEN
        sortBy: APR
        sortDir: DESC
        minInvestmentAgeDays: $minInvestmentAgeDays
        minValueUsd: $minValueUsd
      ) {
        edges {
          node {
            id
            analytics {
              apr
            }
            pair {
              assetBase {
                asset
                type
                chain
                metadata {
                  symbol
                }
              }
              assetQuote {
                asset
                type
                chain
                metadata {
                  symbol
                }
              }
            }
          }
        }
      }
    }
  }
`;
